import styled from "styled-components";

export default styled.button`
  border: none;
  outline: none;
  cursor: pointer;
  margin: 0;
  padding: 0 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  color: #1a5690;
`;
